import { render, staticRenderFns } from "./CalendarIcon.vue?vue&type=template&id=8562f014&scoped=true&"
import script from "./CalendarIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalendarIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8562f014",
  null
  
)

export default component.exports